var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcContentOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-content-off_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#F3F4F8"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-content-off_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M23.429 10.486h-5.793c-.456 0-.893-.178-1.211-.494l-1.254-1.24a2.62 2.62 0 0 0-1.842-.75h-2.758C9.151 8 8 9.113 8 10.487v11.186c0 1.373 1.15 2.485 2.571 2.485H23.43c1.42 0 2.571-1.112 2.571-2.485v-8.7c0-1.374-1.15-2.486-2.571-2.486M12.82 16.389c0-.857.72-1.553 1.608-1.553.887 0 1.607.696 1.607 1.553 0 .858-.72 1.554-1.607 1.554-.888 0-1.608-.696-1.608-1.554m5.857 5.283h-3.356c-.405 0-.646-.439-.418-.765l1.678-2.374a.515.515 0 0 1 .833 0l1.678 2.374c.228.323-.01.765-.418.765zm2.822-4.36c0 .348-.293.63-.652.63h-1.913a.64.64 0 0 1-.652-.63v-1.849c0-.348.292-.63.652-.63h1.913c.36 0 .652.282.652.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DADEE5",
  d: "M23.429 24.158H10.57C9.151 24.158 8 23.045 8 21.672v1.842C8 24.888 9.15 26 10.571 26H23.43C24.849 26 26 24.888 26 23.514v-1.842c0 1.373-1.15 2.486-2.571 2.486"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-content-off_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-content-off_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 8h18v18H8z"
})))));
export default SvgIcContentOff;